export const urls = {
  inStockNotifications: () => "/api/client/v1/inbox/in-stock-notifications/",
  inStockNotification: (id: number) => `/api/client/v1/inbox/in-stock-notifications/${id}/`,
  unsubscribes: () => "/api/client/v1/inbox/unsubscribes/",
  unsubscribe: (id: number) => `/api/client/v1/inbox/unsubscribes/${id}/`,
  clientPrimaryContactPreferences: () => "/api/client/v1/inbox/primary-contact-preferences/",
};

export const keys = {
  all: () => ["inbox-all"],
  primaryContactPreferences: () => [...keys.all(), "primary-contact-preferences"],
  primaryContactPreferencesDetail: () => [...keys.primaryContactPreferences(), "detail"],
};
